module.exports = __webpack_public_path__ + "img/p1-c1-p3.e11b8568.jpg";